import { Button, Col, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { ColDef } from "ag-grid-enterprise";
import { useLoader } from "../../context/LoaderContext";
import { useNavigate } from "react-router-dom";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import EditIcon from "@mui/icons-material/Edit";
import {  
  EmailTemplateReq,
  ReqTemplateType,
} from "../../types/EmailTemplateModel";
import {  
  EmailtemplatestatusUpdate,
  getTemplateTypeData,
} from "../../api/emailTemplateApi/emailTemplateApi";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import BlockIcon from "@mui/icons-material/Block";
import "./EmailTemplate.css";
import { Tooltip } from "@mui/material";
import FileUploads from "../Alert/FileUploads";
import { useSnackbar } from "../Common/SnackbarContext";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";
import { DownloadExcel } from "../../api/fileLocationApi/fileLocationApi";

const EmailTempalte = () => {
  const { showSnackbar } = useSnackbar();
  const [rowData, setRowData] = useState<any[]>([]);
  const { setLoading } = useLoader();
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const gridRef = useRef<AgGridReact>(null);
  const navigation = useNavigate();
  const [uploadFilesOpen, setUploadFilesOpen] = useState(false);

  const handelCreateNew = () => {
    navigation("/emailTemplateEditAction");
  };

  const handleDeactivate = async (
    emailTemplateId: number,
    activate: boolean
  ) => {
    setLoading(true);
    try {
      const payload: EmailTemplateReq = {
        emailTemplateId: emailTemplateId,
        active: activate,
        contextName: LocalStorageUtil.getItem("contextName") ?? "",
      };

      const response = await EmailtemplatestatusUpdate(payload);
      if (response) {
        getData();
        showSnackbar("Email template updated successfully");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const actionCellRenderer = (props: any) => {
    if (props.data === undefined) {
      return "";
    } else {
      const handleEditAction = () => {
        const selectedRowData = props.data;
        navigation("/emailTemplateEditAction", {
          state: { rowData: selectedRowData, action: "Edit" },
        });
      };
      return (
        <>
          {isPagePermission("Allow Edit", "Email", 453) && (
            <Tooltip title="Click to edit Email template">
              <button
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--aggrid-text-color)",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                <EditIcon
                  className="icon-button-other"
                  onClick={handleEditAction}
                />
              </button>
            </Tooltip>
          )}
          <button
            style={{
              background: "none",
              border: "none",
              color: "var(--aggrid-text-color)",
              cursor: "pointer",
              padding: 0,
            }}
          >
            {props.data.active ? (
              <Tooltip
                title="Click to deactivate"
                data-testid="deactivate-tooltip-email-template"
              >
                <PlayCircleIcon
                  onClick={() =>
                    handleDeactivate(props.data.emailTemplateId, false)
                  }
                  className="icon-button-other"
                  style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
                />
              </Tooltip>
            ) : (
              <Tooltip title="Click to activate">
                <BlockIcon
                  onClick={() =>
                    handleDeactivate(props.data.emailTemplateId, true)
                  }
                  className="icon-button-other"
                  style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
                />
              </Tooltip>
            )}
          </button>
        </>
      );
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const [columnDefs] = useState<ColDef[]>([
    {
      headerName: "#",
      width: 70,
      suppressSizeToFit: true,
      colId: "colRowNum",
      sortable: false,
      filter: false,
      resizable: false,
      enableRowGroup: false,
      valueGetter: (params: any) => {
        return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
      },
    },
    {
      headerName: "Email Template Name",
      field: "templateName",
      tooltipField: "templateName",
      flex: 1,
      colId: "templateName",
      enableRowGroup: true,
      sortable: true,
      filter: true,
      resizable: false,
    },
    {
      headerName: "Group Name",
      field: "emailTemplateGroupName",
      tooltipField: "emailTemplateGroupName",
      flex: 1,
      colId: "emailTemplateGroupName",
      enableRowGroup: true,
      sortable: true,
      filter: true,
      resizable: false,
    },
    {
      headerName: "Description",
      field: "description",
      tooltipField: "description",
      colId: "description",
      enableRowGroup: true,
      sortable: true,
      filter: true,
      resizable: false,
      flex: 1,
    },
    {
      headerName: "Actions",
      field: "link",
      cellRenderer: actionCellRenderer,
      lockPinned: true,
      suppressSizeToFit: true,
      width: 100,
      minWidth: 100,
      pinned: "right",
      sortable: false,
      filter: false,
      resizable: false,
      enableRowGroup: false,
    },
  ]);

  const getData = async () => {
    setLoading(true);
    const payload: ReqTemplateType = {
      accountId: LocalStorageUtil.getItem("accountId")
        ? Number(LocalStorageUtil.getItem("accountId"))
        : 0,
      searchText: "",
      contextName: LocalStorageUtil.getItem("contextName") ?? "",
      currentPage: 1,
      noOfRecords: 0,
      sortColumn: "",
      sortOrder: 0,
    };
    try {
      const userData = await getTemplateTypeData(payload);
      setRowData(userData.listEmailTemplateModel);
    } catch (error) {
      showSnackbar("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  //Quick Filter
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current!.api.setGridOption(
      "quickFilterText",
      (document.getElementById("filter-text-box") as HTMLInputElement).value
    );
  }, []);

  const handelUploadFiles = () => {
    setUploadFilesOpen(true);
  };

  const closeUploadFiles = (isCancelClick: boolean) => {
    setUploadFilesOpen(false);
    if (!isCancelClick) {
      getData();
    }
  };

  //Donwload File Function
  const downloadFile = async () => {
    setLoading(true);
    try {
      const params: any = {
        IsSuperAdmin: 1,
        AccountId: LocalStorageUtil.getItem("accountId"),
        isexporttpExcel: true,
        pagename: "EmailTemplate",
        aliasname: "EmailTemplate",
        businessUnitId: LocalStorageUtil.getItem("businessUnitId")
          ? Number(LocalStorageUtil.getItem("businessUnitId"))
          : 0,
        contextName: LocalStorageUtil.getItem("contextName")?.toString(),
        offset: appSettings.timezone,
      };
      const response = await DownloadExcel(params);
      if (response && response.status === 200 && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const filename =
          "EmailTemplate_" + new Date().toISOString().split("T")[0] + ".xlsx";
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);

        showSnackbar("File downloaded successfully");
      } else {
        showSnackbar("Unable to download file !", true);
      }
    } catch (e) {
      showSnackbar("Error in Email Template downloading", true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <NavigationBar
        menuTitle="Configuration"
        title="Email Template"
        text="Email Template"
      />
      <Row style={{ margin: "1em" }}>
        <Col xs={12}>
          <div
            className="rp-main-inner col-sm-12"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {/* Quick Filter section */}

            <div
              className="col-sm-5"
              style={{
                width: "48%",
                padding: ".5em",
                marginTop: ".1em",
              }}
            >
              <input
                type="text"
                id="filter-text-box"
                placeholder="Quick Filter..."
                style={{
                  width: "25em",
                  height: "2.5em",
                  fontSize: "11px",
                  paddingLeft: ".5em",
                  marginBottom: ".1em",
                }}
                onInput={onFilterTextBoxChanged}
              />
            </div>
            <div
              className="col-sm-5"
              style={{
                width: "45%",
                textAlign: "right",
              }}
            >
              {isPagePermission("Allow Create New", "Email", 452) && (
                <Button
                  variant="contained"
                  size="sm"
                  className="button createnew-button"
                  onClick={handelCreateNew}
                >
                  Create new
                </Button>
              )}
              {isPagePermission("Allow Download Template", "Email", 1372) && (
                <Button
                  variant="contained"
                  size="sm"
                  className="button email-download-template-button"
                  onClick={downloadFile}
                >
                  Download Template
                </Button>
              )}
              {isPagePermission("Allow Upload Template", "Email", 1373) && (
                <Button
                  variant="contained"
                  size="sm"
                  className="button"
                  onClick={handelUploadFiles}
                >
                  Upload
                </Button>
              )}
            </div>
          </div>
          <div className="rp-main-inner col-sm-12">
            {/* Ag-Grid Section */}
            <div className="rp-main-inner col-sm-12">
              <div
                className="ag-theme-quartz-dark"
                style={{
                  height: "66vh",
                  marginTop: ".1vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={rowData}
                  pagination={true}
                  paginationPageSize={defaulPageSize}
                  paginationPageSizeSelector={pageSizeSelector}
                  rowGroupPanelShow="always"
                  pivotPanelShow="always"
                  ref={gridRef}
                  headerHeight={30}
                  loading={!rowData}
                  overlayNoRowsTemplate={
                    '<span class="ag-overlay-loading-center">No rows to show</span>'
                  }
                  loadingOverlayComponent={CustomLoadingOverlay}
                />
              </div>
            </div>
          </div>
          {uploadFilesOpen && (
            <FileUploads
              isOpen={uploadFilesOpen}
              onClose={closeUploadFiles}
              title="Upload Files"
              selectedData={null}
              screenType="EmailTemplate"
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EmailTempalte;
